
// Paginação anterior/próxima via ajax da listagem simples de components/list-blog.php
const buildListBlogPageBase = () => {

    const url = new URL( window.location.href )
    url.pathname = url.pathname.replace( /\/page\/\d+\/?$/, '/' ).replace( /\/?$/, '/' )

    return url

}

const buildListBlogPageUrl = ( base, paged ) => {

    const url = new URL( base )
    if( paged > 1 ) url.pathname = url.pathname.replace( /\/$/, '' ) + '/page/' + paged + '/'

    return url

}

const fetchListBlogPage = ( section, paged ) => {

    const base = buildListBlogPageBase()
    const url = buildListBlogPageUrl( base, paged )

    const params = new URLSearchParams({
        action: 'flivre_list_blog_page',
        paged,
        categoria: section.dataset.categ || '',
        categoria_tax: section.dataset.categTax || 'category',
        tipo: section.dataset.type || 'noticias',
        base_url: base.pathname + base.search,
    })

    section.classList.add( 'loading' )

    return fetch( Piki.ajaxurl + '?' + params.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
        .then( response => response.json() )
        .then( data => {

            if( data.status !== 'success' ) return

            section.querySelector( 'ul' ).innerHTML = data.posts
            section.querySelector( '.pagination-wrap' ).innerHTML = data.pagination

            window.history.pushState( {}, '', url )

            section.scrollIntoView({ behavior: 'smooth', block: 'start' })

        })
        .finally( () => {
            section.classList.remove( 'loading' )
        })

}

window.addEventListener( 'DOMContentLoaded', () => {

    const section = document.querySelector( 'section.list-blog' )
    if( !section ) return

    section.addEventListener( 'click', ( event ) => {

        const link = event.target.closest( '.pagination-wrap a[data-page]' )
        if( !link ) return

        event.preventDefault()

        fetchListBlogPage( section, Number( link.dataset.page ) )

    })

})
